import Swiper from 'swiper'
import { Pagination, Navigation, Autoplay } from 'swiper/modules'
import 'swiper/css'
import LazyLoad from 'vanilla-lazyload'

class VideoCarousel extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    const swiper = new Swiper(this, {
      // Optional parameters
      slidesPerView: 1,
      modules: [Pagination, Navigation, Autoplay],
      loop: true,
      pagination: {
        el: this.querySelector('.hero-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-video-next',
        prevEl: '.swiper-video-prev',
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
    })

    const lazyLoadInstance = new LazyLoad({
      elements_selector: '.lazy',
      // ... more custom settings?
    })

    if (lazyLoadInstance) {
      lazyLoadInstance.update()
    }
  }
}
customElements.define('video-carousel', VideoCarousel)
